import { useRef, useState } from "react";
import ContainerCard from "./ContainerCard";
import LanguageList from "./LanguageList";
import LearningPlans from "./LearningPlans";
import ScheduleList from "./ScheduleList";
import axios from "axios";
import {
  Modal,
  ModalHeader,
  OverlayTrigger,
  Spinner,
  Tooltip,
} from "react-bootstrap";
import ReviewConfirmCourses from "./ReviewConfirmCourses";
import { useAppContext } from "../../contexts/AppContext";

import Select from "react-select";
import {
  getAllGroupMembers,
  queryGroups,
} from "../../services/poweruserServices";
import ConfirmationScreen from "./ConfirmationScreen";
import LocationModal from "./LocationModal";
import InpersonClassSelectionModal from "./InpersonClassSelectionModal";
import CompletedPage from "./CompletedPage";
import CustomTooltip from "./CustomTooltip/CustomTooltip";
import EnrollPDFMyDocumentBT30 from "./EnrollPDF/EnrollPDFMyDocumentBT30"
import { pdf } from "@react-pdf/renderer";

import JSZip from "jszip";
import { saveAs } from "file-saver";

const LandingPage = () => {
  const [currentStep, setCurrentStep] = useState(1);
  const [totalStep] = useState(4);
  const [languages, setLanguages] = useState([]);
  const [learningPlan, setLearningPlan] = useState([]);
  const [selectedLanguage, setSelectedLanguage] = useState("");
  const [isBT30, setIsBT30] = useState(false);
  const [coursesIds, setCourseIds] = useState([]);
  const [groupedSessions, setGroupedSessions] = useState([]);
  const [availableCountData, setAvailableCountData] = useState([]);
  const [hasAvailableSpots, setHasAvailableSpots] = useState(false);
  const [sessionFilledMsgDisplay, setSessionFilledMsg] = useState(false);
  const availableCountDataRef = useRef([]);
  const sessionBeforeSessionDetailLoad = useRef([]);
  const clickBeforeSessionDetailLoad = useRef(false);
  const [filteredSessions, setFilteredSessions] = useState([]);
  const [filteredSessions2, setFilteredSessions2] = useState([]);
  const [loading, setLoading] = useState(false);
  const [enrollBt30Loading, setEnrollBt30Loading] = useState(false);
  const [validationATV3Loading, setValidationATV3Loading] = useState(false);
  const [isAvailableCountLoading, setAvailableCountLoading] = useState(false);
  const [cityOptions, setCityOptions] = useState([]);
  const [cities, setCity] = useState([]);
  const [selectedSession, setSelectedSession] = useState([]);
  const [isSessionSelected, setIsSessionSelected] = useState(false);
  const [onlineSessions, setOnlineSessions] = useState([]);
  const { currentUser } = useAppContext();
  const enrollSelectBox = useRef(null);
  const [showEnrollModal, setShowEnrollModal] = useState(false);
  const [defaultListGroupOptions, setDefaultListGroupOptions] = useState([]);
  const [isListBoxLoading, setIsListBoxLoading] = useState(false);
  const [selectBoxValuesGroup, setSelectBoxValuesGroup] = useState();
  const [groupUsers, setGroupUsers] = useState([]);
  const [defaultListOptions, setDefaultListOptions] = useState([]);
  const [selectBoxValues, setSelectBoxValues] = useState();
  const [showViewSessionConfirm, setShowViewSessionConfirm] = useState(false);
  const [sessionForEnroll, setSessionForEnroll] = useState([]);
  const [selectedCohort, setSelectedCohort] = useState([]);
  const [result, setResult] = useState({});
  const [status, setStatus] = useState("");
  const [enrolledSessionList, setEnrolledSessionList] = useState([]);
  const [showResult, setShowResult] = useState(false);
  const [showViewFullScheduleList, setShowhowViewFullScheduleList] =
    useState(false);
  const [showViewDashboardPopup, setShowViewDashboardPopup] = useState(false);
  const [showEnrollConfirm, setShowEnrollConfirm] = useState(false);
  const [prowerUserMsg, setProwerUserMsg] = useState(false);
  const [selectedLocation, setSelectedLocation] = useState(null);
  const [showLocationModal, setShowLocationModal] = useState(false);
  const [showInpersonSelectionModal, setShowInpersonSelectionModal] =
    useState(false);
  const [otherSessionList, setotherSessionList] = useState([]);
  const [selectedCity, setSelectedCity] = useState("");
  const [selectedCityAddress, setSelectedCityAddress] = useState("");
  const [conformationText, setConformationText] = useState(null);
  const showBt30EnrollRef = useRef(false);
  const [errorMesgaeStep, setErrorMesgaeStep] = useState(0);

const filterOptions = (candidate, input) => {
  const search = input.toLowerCase();

  return (
    candidate.data.label.toLowerCase().includes(search) ||
    candidate.data.email.toLowerCase().includes(search) ||
    candidate.data.value.toString().toLowerCase().includes(search) ||
    candidate.data.firstname.toLowerCase().includes(search) ||
      candidate.data.lastname.toLowerCase().includes(search) ||

      (candidate.data.firstname + ' ' + candidate.data.lastname)
          .toLowerCase()
          .includes(search)
  );
};

  const handleSelectChangeGroup = async (selectedOptions) => {
    setIsListBoxLoading(true);
    setSelectBoxValuesGroup(selectedOptions);
    let groupId = selectedOptions.value.toString();
    let groupUsers = await getAllGroupMembers(groupId);

    let listGroupUsers = groupUsers.map((item) => {
      return {
        value: item.id,
        label: item.username+" ( "+item.firstname+" "+item.lastname+" )",
        type: "user",
        email: item.email,
        firstname: item.firstname,
        lastname: item.lastname,
         username:item.username
      };
    });

    setGroupUsers(listGroupUsers);
    setDefaultListOptions(listGroupUsers);
    setIsListBoxLoading(false);
    return listGroupUsers;
  };

  const enrollInCoursesAndSessions = async (
    userIds,
    groupIds,
    branchIds,
    selectedSessions,
  ) => {
    var resultObj = {};

    try {
      if (userIds.length > 0) {
        setStatus("Enrolling users to learning plan..");

        const userResp = await axios.post(
            `${process.env.REACT_APP_API_DOMAIN}/enrollment/users_to_lp${window.location.search}`,
          {
            userIds,
            learningPlanId: learningPlan.id,
          },
          { withCredentials: true }
        );

        resultObj.userToLpResult = userResp;
      }

      if (groupIds.length > 0) {
        setStatus("Enrolling group to learning plan..");

        const groupResp = await axios.post(
            `${process.env.REACT_APP_API_DOMAIN}/enrollment/groups_to_lp${window.location.search}`,
          {
            groupIds,
            learningPlanId: learningPlan.id,
          },
          { withCredentials: true }
        );

        resultObj.groupToLpResult = groupResp;
      }

      if (branchIds.length > 0) {
        setStatus("Enrolling branches to learning plan..");

        const branchResp = await axios.post(
            `${process.env.REACT_APP_API_DOMAIN}/enrollment/branches_to_lp${window.location.search}`,
          {
            branchIds,
            learningPlanId: learningPlan.id,
          },
          { withCredentials: true }
        );

        resultObj.branchToLpResult = branchResp;
      }

      let userErrors = resultObj?.userToLpResult?.data?.filter(
        (d) => d.status >= 400
      );
      let groupErrors = resultObj?.groupToLpResult?.data?.filter(
        (d) => d.status >= 400
      );
      let branchErrors = resultObj?.branchToLpResult?.data?.filter(
        (d) => d.status >= 400
      );

      if (userErrors || groupErrors || branchErrors) {
      } else {
        setStatus("Learning plan enrollment completed..");
      }

      setStatus("Fetching sessions..");

      let getPastSessions = currentUser.isPowerUser; //power user can see past sessions

      setStatus("Enrolling to sessions..");

      let sessions = selectedCohort.sessions.sessions.map((s) => {
        return { sessionId: s.id, courseId: s.courseid };
      });

      resultObj = {};

      let sessionResponse = await axios.post(
          `${process.env.REACT_APP_API_DOMAIN}/enrollment${window.location.search}`,
        {
          userIds,
          groupIds,
          branchIds,
          sessions: sessions,
        },
        { withCredentials: true }
      );
 if (sessionResponse?.data) {
        let existingEnrollments = [];
        resultObj.enrolled = sessionResponse.data
          .map((d) => d?.enrolled)
          .flat(1)
          .filter((e) => e != null);
        if (currentUser.isPowerUser) {
          existingEnrollments = sessionResponse.data
            .flatMap((d) => {
              // Case 1: errors.existing_enrollments (object form)
              if (Array.isArray(d?.errors?.existing_enrollments)) {
                return d.errors.existing_enrollments;
              }

              // Case 2: errors is directly an array
              if (Array.isArray(d?.errors)) {
                return d.errors;
              }

              return [];
            })
            .filter((e) => e != null);

          resultObj.existing_enrollments = existingEnrollments;

          resultObj.extsingEnroll_Data = sessionResponse.data
            .flatMap((d) => {
              if (Array.isArray(d?.errors)) {
                // Case: errors is an array
                return d.errors;
              }

              if (Array.isArray(d?.errors?.existing_enrollments)) {
                // Case: errors.existing_enrollments
                return d.errors.existing_enrollments;
              }

              return [];
            })
            .map((str) => {
              const match = str.match(
                /id_user:\s*(\d+)\s+and\s+id_course:\s*(\d+)/,
              );

              if (!match) return null;

              return {
                id_user: Number(match[1]),
                id_course: Number(match[2]),
                waiting: false,
              };
            })
            .filter(Boolean);


          resultObj.errors = sessionResponse.data
            .flatMap((d) => {
              // Case 1: errors.existing_enrollments (object form)
              if (Array.isArray(d?.errors?.existing_enrollments)) {
                return d.errors.existing_enrollments;
              }

              // Case 2: errors is directly an array
              if (Array.isArray(d?.errors)) {
                return d.errors;
              }

              return [];
            })
            .filter((e) => e != null);

          const pendingSessions = selectBoxValues.flatMap((user) => {
            const userId = user.value;
 const sessions = selectedCohort?.sessions?.sessions ?? [];
            return (
              sessions
                ?.filter(
                  (session) =>
                    !resultObj.enrolled.some(
                      (e) =>
                        e.id_user === userId &&
                        e.id_course === Number(session.courseid),
                    ) &&
                    !resultObj.extsingEnroll_Data.some(
                      (e) =>
                        e.id_user === userId &&
                        e.id_course === Number(session.courseid),
                    ),
                )
                .map((session) => ({
                  id_user: userId,
                  id_course: session.courseid,
                  waiting: false,
                })) ?? []
            );
          });
          resultObj.penddingsessions = pendingSessions;
        } else {
          existingEnrollments = sessionResponse.data
            .map((d) => d?.errors)
            .flat(1)
            .filter((e) => e?.startsWith("The enrollments already exists"));

          resultObj.existing_enrollments = existingEnrollments;

          resultObj.errors = sessionResponse.data
            .map((d) => d?.errors)
            .flat(1)
            .filter(
              (e) =>
                !e?.startsWith("The enrollments already exists") && e != null,
            );
        }

        const enrolledCourseIds =
          resultObj.enrolled?.map((item) => item.id_course.toString()) || [];

        const unableToJoinSessions = selectedSessions.sessions.sessions.filter(
          (item) => !enrolledCourseIds.includes(item.courseid)
        );

        setEnrolledSessionList((prevList) =>
          prevList.map((group) => {
            if (!Array.isArray(group["1"])) return group;

            const updatedSessions = group["1"].map((session) => {
              const searchString = `id_course: ${String(session.courseId)}`;
              const alreadyExists = resultObj.existing_enrollments?.some(
                (msg) => msg.includes(searchString)
              );

              let enrolledStatus = "Not Enrolled";
              if (alreadyExists) {
                enrolledStatus = "Already Enrolled";
              } else if (enrolledCourseIds.includes(String(session.courseId))) {
                enrolledStatus = "Enrolled";
              }

              return { ...session, enrolledStatus };
            });

            return { ...group, 1: updatedSessions };
          })
        );
        if (currentUser.isPowerUser === false) {
          if (
            resultObj.enrolled &&
            resultObj.enrolled.length + (existingEnrollments?.length || 0) !==
              selectedCohort.length
          ) {
            const pendingSessions = selectedCohort.sessions.sessions?.filter((parent) =>
            unableToJoinSessions?.some(
              (item) => item?.courseid === parent?.courseid
            )
          );

            resultObj.penddingsessions = pendingSessions;
          }
        }
      }
    } catch (error) {
      resultObj.errors = error;
      console.error(error);
    }

    setResult(resultObj);
    setShowResult(true);
    setShowhowViewFullScheduleList(false);
    setShowViewDashboardPopup(true);
  };

  const onModalEnrollClickHandler = async (callingFrom) => {
    if (callingFrom !== "EnrollPopup") {
      setEnrollBt30Loading(true);
    }
    if (currentUser.isPowerUser) {
      setProwerUserMsg(true);
      defaultListGroupOptions.length <= 0 && getPowerUserGroups();
    }
    let users = selectBoxValues.filter((value) => value.type === "user");
    let groups = selectBoxValues.filter((value) => value.type === "group");
    let branches = selectBoxValues.filter((value) => value.type === "branch");

    let userIds = users.map((user) => user.value);
    let groupIds = groups.map((group) => group.value);
    let branchIds = branches.map((branch) => branch.value);

    await enrollInCoursesAndSessions(
      userIds,
      groupIds,
      branchIds,
      selectedCohort
    );

    setShowViewSessionConfirm(false);
    setSessionForEnroll([]);
    setShowEnrollModal(false);
    setLoading(false);
  };

  const onEnrollClickHandler = () => {
    setSelectedCohort(selectedSession);
    if (currentUser.isPowerUser) {
      setShowEnrollModal(true);
    } else {
      setShowEnrollConfirm(true);
    }
  };

  const getPowerUserGroups = async () => {
    setIsListBoxLoading(true);
    let userGroups = await queryGroups(currentUser.user_id);

    var result = userGroups.map((item) => {
      return { value: item.id, label: item.name, type: "group" };
    });

    setDefaultListGroupOptions(result);
    setIsListBoxLoading(false);

    if (result.length > 0) {
      const firstGroup = result[0];
      setSelectBoxValuesGroup(firstGroup);
      await handleSelectChangeGroup(firstGroup);
    }

    return result;
  };

  const onConfirmEnrollClick = async () => {
    setEnrollBt30Loading(true);
    await enrollUser();
    setEnrollBt30Loading(false);
    setLoading(false);
    setShowViewSessionConfirm(false);
    setShowEnrollConfirm(false);
    setotherSessionList([]);
    setSessionForEnroll([]);
  };

  const enrollUser = async () => {
    var resultObj = {};
    try {
      let userIds = [currentUser.user_id]; //convert to array to use existing endpoint
      const userResp = await axios.post(
          `${process.env.REACT_APP_API_DOMAIN}/enrollment/users_to_lp${window.location.search}`,
        {
          userIds,
          learningPlanId: learningPlan.id,
        },
        { withCredentials: true }
      );

      // let _groupedSessions = await getAllSessions(learningPlan, false);

      //let cohort = _groupedSessions.find(
      //  (x) => x.cohortId === selectedCohort.cohortId
      // );

      //var selectedSessions = cohort.sessions.map((s) => {
      //  return { sessionId: s.id, courseId: s.course_id };
      //});

      var selectedSessions = selectedCohort.sessions.sessions.map((s) => {
        return { sessionId: s.id, courseId: s.courseid };
      });

      var branchIds = []; //send in request to avoid errors
      var groupIds = []; //send in request to avoid errors

      var sessionResponse = await axios.post(
          `${process.env.REACT_APP_API_DOMAIN}/enrollment${window.location.search}`,
        {
          userIds,
          groupIds,
          branchIds,
          sessions: selectedSessions,
        },
        { withCredentials: true }
      );

      const existingEnrollments = sessionResponse.data
        .map((d) => d?.errors)
        .flat(1)
        .filter((e) => e?.startsWith("The enrollments already exists"));
      resultObj.existing_enrollments = existingEnrollments;
      resultObj.errors = sessionResponse.data
        .map((d) => d?.errors)
        .flat(1)
        .filter(
          (e) => !e?.startsWith("The enrollments already exists") && e != null
        );

      resultObj.enrolled = sessionResponse.data
        .map((d) => d?.enrolled)
        .flat(1)
        .filter((e) => e != null);

      if (resultObj.enrolled && resultObj.enrolled.length > 0) {
        let exixtingenroll = 0;
        if (
          resultObj.existing_enrollments &&
          resultObj.existing_enrollments.length > 0
        ) {
          //exixtingenroll=resultObj.existing_enrollments.length;
          exixtingenroll = 0;
        }
        if (
          resultObj.enrolled.length + exixtingenroll !==
          selectedCohort.length
        ) {
          const enrolledcorseid = resultObj.enrolled.map((item) =>
            item.id_course.toString()
          );

          const unabletojoinsession = selectedSessions.filter(
            (item) => !enrolledcorseid.includes(item.courseId)
          );

          const penddingsessions = selectedCohort.sessions.sessions?.filter(
            (parent) => {
              return unabletojoinsession?.some(
                (item) => item?.courseId === parent?.courseid
              );
            }
          );

          resultObj.penddingsessions = penddingsessions;
        }
        //   var penddingsessions=_groupedSessions.filter((e)=>unabletojoinsession.courseId.includes(e.course_id));
      }

      setResult(resultObj);
      setShowResult(true);
      setShowEnrollConfirm(false);
      setShowEnrollModal(false);
      setShowViewDashboardPopup(true);
      setEnrollBt30Loading(false);
    } catch (error) {
      console.error(error);
    }
  };

  const formatDate = (dateStr) => {
    const options = {
      weekday: "short",
      month: "short",
      day: "numeric",
      year: "numeric",
    };
    return new Date(dateStr).toLocaleDateString("en-US", options);
  };
  const formatTime = (dateStr) => {
    const options = { hour: "numeric", minute: "numeric", hour12: true };
    return new Date(dateStr).toLocaleTimeString("en-US", options);
  };

  const onViewSessionClickHandler = async (session) => {
    // if (availableCountData.length == 0) {
    //   clickBeforeSessionDetailLoad.current = true;
    //   sessionBeforeSessionDetailLoad.current = session;

    //   setLoading(true);
    //   setShowhowViewFullScheduleList(true);

    //   const sorted = [...session.sessions].sort(
    //     (a, b) => new Date(a.date_start) - new Date(b.date_start),

    //   );
    //   setSessionForEnroll(session);
    //   console.log("sorted", sorted);
    //   setotherSessionList(sorted);
    // } else {
    // if (currentUser.isPowerUser) {
    //   const hasAvailableSpot = availableCountData.filter((item1) =>
    //     session.sessions.some((item2) => item2.id === item1.id),
    //   ).some((item1) => {
    //     const remainingList1 =
    //       Number(item1.max_enroll) - Number(item1.enrolled);

    //     return remainingList1 > 0;
    //   });
    //   setHasAvailableSpots(hasAvailableSpot);
    //   const sessionMsgDisplay = availableCountData.filter((item1) =>
    //     session.sessions.some((item2) => item2.id === item1.id),
    //   ).every((item1) => {
    //     const remainingList1 =
    //       Number(item1.max_enroll) - Number(item1.enrolled);

    //     return remainingList1 !== 0;
    //   });
    //   setSessionFilledMsg(sessionMsgDisplay);
    // } else {
    //   const hasAvailableSpot = availableCountData.filter((item1) =>
    //     session.sessions.some((item2) => item2.id === item1.id),
    //   ).every((item1) => {
    //     const remainingList1 =
    //       Number(item1.max_enroll) - Number(item1.enrolled);

    //     return remainingList1 !== 0;
    //   });
    //   setHasAvailableSpots(hasAvailableSpot);
    //   setSessionFilledMsg(hasAvailableSpot);
    // }

    setShowhowViewFullScheduleList(true);

    const sorted = [...session].sort(
      (a, b) => new Date(a.date_start) - new Date(b.date_start)
    );

    var dataAranged = sorted.map((session) => {
      const courseId = session.courseid;
      const course = learningPlan.courses.find((c) => c.id_course === courseId);
      const moduleName = course ? course?.name : "Unknown Module";

      return {
        date: formatDate(session.startdatetime),
        time: formatTime(session.startdatetime),
        startTime: formatTime(session.date_start),
        endTime: formatTime(session.date_end),
        rawDate: new Date(session.startdatetime),
        locationType: session.attendance_type,
        duration: session.hours,
        module: moduleName,
        seats: parseInt(session.max_enroll) - parseInt(session.enrolled),
        city:
          session.cityname === "Webinar" ? "Online" : session.cityname || "-",
        cityLinkText:
          session.attendance_type === "online" || session.cityname === "Webinar"
            ? ""
            : session.cityname,
        cityLink: session.location || "#",
        courseId: session.courseid,
      };
    });

    setSelectedCity(session[0].cityname);
    setSelectedCityAddress(session[0].location.name);

    const groupedSchedule = Object.entries(
      dataAranged.reduce((acc, entry) => {
        (acc[entry.date] ??= []).push(entry);
        return acc;
      }, {})
    ).sort(
      ([, entriesA], [, entriesB]) =>
        new Date(entriesA[0].rawDate) - new Date(entriesB[0].rawDate)
    );
    setotherSessionList(groupedSchedule);
    setEnrolledSessionList(groupedSchedule);
    setSessionForEnroll(session);
    setShowViewSessionConfirm(true);
    //}
  };

  const stepContent = {
    1: {
      heading: "Please select your language.",
      subheading:"Choose the language you are most comfortable reading in. If your preferred language is not listed, please contact the Member Resource Center for assistance.",
    },
    2: {
        heading: currentUser.AHCASEligible === 1 ? "Please select an Advanced Training." : currentUser.isPowerUser ? "Select a training." : "Select a Basic Training.",
      
      subheading: "The options available for you will be shown below.",
    },
    3: {
      heading: isBT30
        ? "Select your in person course."
        : "Choose the start date and view the full schedule to enroll.",
      subheading: isBT30
        ? "An extra 30 minutes has been added for Union Time. All classes shown are in Pacific Time Zone."
        : learningPlan?.headingtext,
    },
    4: {
      heading: "Review your Online Courses",
      subheading: (
        <div style={{ fontSize: "13px" }}>
          <div>
            In addition to your 3 hour in-person class, you will be enrolled in
            7 hours of mandatory online courses.
          </div>
          {/* <div>Elective classes may be chosen after enrollment in BT30.</div> */}
        </div>
      ),
    },
    5: {
      heading: "Enrollment Support.",
      subheading: "",
    },
  };

  const handlePrev = () => {
    setIsSessionSelected(false);
    setCurrentStep((prev) => Math.max(prev - 1, 1));
  };

  const getOnlineCourseList = async () => {
    setLoading(true);
    try {
      const response = await axios.post(
          `${process.env.REACT_APP_API_DOMAIN}/learningplan/onlinecourselist${window.location.search}`,
        {
          LearningPlanId: learningPlan?.id,
          }, { withCredentials: true }
      );
      setOnlineSessions(response.data);
      setLoading(false);
    } catch (error) {
      console.log(error);
    }
  };

  const handleSelectPlan = async (plan, isBT30) => {
  
    if (currentUser.AHCASEligible === 1) {
      if (plan.code.includes("AT")) {
        setValidationATV3Loading(true);
        const response = await axios.post(
            `${process.env.REACT_APP_API_DOMAIN}/learningplan/atv3/validation${window.location.search}`,
          {
            Username: currentUser.username,
            LearningPlanId: Number(plan.id),
            }, { withCredentials: true }
        );
        if (response.data?.length === 0) {
          getAvailableCounts(plan);
          setLoading(true);
          await getAllCoursesSessionsForSessionPage(plan);
          await getAllCity();
          setLearningPlan(plan);
          setConformationText(plan?.conformationText);
          setIsBT30(isBT30);
          setCurrentStep(3);
          setLoading(false);
          setValidationATV3Loading(false);
        } else {
            const validationData = response.data.filter(
                (x) => x.status === 1 || x.status === 0 || x.status === 2,
            );
            if (validationData.length > 0) {
                setCurrentStep(5);
                // getAvailableCounts(plan);
                // setLoading(true);
                // await getAllCoursesSessionsForSessionPage(plan);
                // await getAllCity();
                // setLearningPlan(plan);
                // setConformationText(plan?.conformationText);
                // setIsBT30(isBT30);
                // setCurrentStep(3);
                // setLoading(false);
                // setValidationATV3Loading(false);
          } else {
            const validationDataCompleted = response.data.filter(
              (x) => x.status === 2
            );
            if (validationDataCompleted.length > 0) {
              setCurrentStep(5);
            } else {
              getAvailableCounts(plan);
              setLoading(true);
              await getAllCoursesSessionsForSessionPage(plan);
              await getAllCity();
              setLearningPlan(plan);
              setConformationText(plan?.conformationText);
              setIsBT30(isBT30);
              setCurrentStep(3);
              setLoading(false);
              setValidationATV3Loading(false);
            }
          }
        }
      } else {
        getAvailableCounts(plan);
        setLoading(true);
        await getAllCoursesSessionsForSessionPage(plan);
        await getAllCity();
        setLearningPlan(plan);
        setConformationText(plan?.conformationText);
        setIsBT30(isBT30);
        setCurrentStep(3);
        setLoading(false);
      }
    } else {
      getAvailableCounts(plan);
      setLoading(true);
      await getAllCoursesSessionsForSessionPage(plan);
      await getAllCity();
      setLearningPlan(plan);
      setConformationText(plan?.conformationText);
      setIsBT30(isBT30);
      setCurrentStep(3);
      setLoading(false);
    }
  };

  const getAllCoursesSessionsForSessionPage = async (learningPlan) => {
    var learningPlanCourses = learningPlan.courses;
    var courseIds = learningPlanCourses.map((course) => course.id_course);

    setCourseIds(courseIds);

    try {
      const response = await axios.post(
          `${process.env.REACT_APP_API_DOMAIN}/course/sessiondetails${window.location.search}`,
        {
          CourseIds: courseIds,
          LearningPlanName: learningPlan.name,
          }, { withCredentials: true }
      );

      if (response.data.length > 0) {
        let sessions = response.data.filter(
          (session) =>
            session.additional_fields.length > 0 &&
            session.additional_fields.find((field) => field.name === "CohortID")
              .value
        );

        sessions = sessions.filter(
          (session) => new Date(session.date_start) >= new Date()
        );
        sessions = sessions.filter(
          (session) => session.name != "This class is Canceled"
        );
        let AllCohorts = sessions.map(
          (s) =>
            s.additional_fields.find((field) => field.name === "CohortID").value
        );
        let uniqueCohorts = [...new Set(AllCohorts)];

        var _groupedSessions = uniqueCohorts.map((cohort) => {
          return {
            cohortId: cohort,
            sessions: sessions
              .filter(
                (session) =>
                  session.additional_fields.find(
                    (field) => field.name === "CohortID"
                  ).value == cohort
              )
              .sort((a, b) => new Date(a.date_start) - new Date(b.date_start)),
          };
        });

        _groupedSessions = _groupedSessions.sort(function (a, b) {
          const dateA = new Date(a.sessions[0].date_start);
          const dateB = new Date(b.sessions[0].date_start);

          return dateA - dateB;
        });

        setGroupedSessions(_groupedSessions);

        setFilteredSessions(_groupedSessions);
      } else {
        setGroupedSessions([]);
        setFilteredSessions([]);
      }
    //  setLoading(false);
    } catch (error) {
      console.log(error);
    }
  };

  const getAvailableCounts = async (learningPlan) => {
    setAvailableCountLoading(true);
    var learningPlanCourses = learningPlan.courses;
    var courseIds = learningPlanCourses.map((course) => course.id_course);

    const response = await axios.post(
        `${process.env.REACT_APP_API_DOMAIN}/course/sessionsdtl${window.location.search}`,
      {
        courseIds,
      },
      { withCredentials: true }
    );
    setAvailableCountData(response.data);
    availableCountDataRef.current = response.data;
    setAvailableCountLoading(false);
  };

  const getAllCity = async () => {
    const response = await axios.post(
        `${process.env.REACT_APP_API_DOMAIN}/location/regionalcity${window.location.search}`,
      {
        currentPage: 0,
        pageSize: 0,
        }, { withCredentials: true }
    );
    const _city = response.data.items;

    const options = _city.map((cty) => ({
      label: cty.name,
      value: cty.name,
    }));

    setCityOptions(options);

    setCity(_city);
  };

  const handleActionChange = async () => {
    if (currentUser.isPowerUser) {
      setProwerUserMsg(true);
      defaultListGroupOptions.length <= 0 && getPowerUserGroups();
    }
    if (currentStep === 3) {
      setShowInpersonSelectionModal(true);
    } else if (currentStep === 4) {
      onEnrollClickHandler(selectedSession);
    }
  };

  const continueEnrollingBt30 = async () => {
    if (currentStep === 3) {
      setShowInpersonSelectionModal(false);
      setCurrentStep(4);
      if (selectedSession.sessions?.sessions?.length > 0) {
        await getOnlineCourseList();
      }
    }
  };

  const handleSelectedSessionToParent = (entry, isSelected) => {
    setIsSessionSelected(isSelected);
    setSelectedSession(entry);
    onViewSessionClickHandler(entry.sessions.sessions);
  };

  const onGoToEnrollmentClick = () => {
    setSelectedLanguage("");
    setCurrentStep(1);
    setShowViewDashboardPopup(false);
  };

  const goBack = () => {
    setCurrentStep(2);
  };
  const handlePrintData = async (enrolledSessionList,result,currentUser,onlineSessions) => {
      
  
  const enrolledCourseIds = new Set(
    result?.enrolled?.map(e => e.id_course.toString())
  );
  
  
  if(enrolledCourseIds.size >0)
  {
  
   const filteredList = enrolledSessionList
    .map(day => {
      const filteredCourses = day["1"].filter(course =>
        enrolledCourseIds.has(course.courseId)
      );
  
      if (filteredCourses.length === 0) return null;
  
      return {
        "0": day["0"],
        "1": filteredCourses
      };
    })
    .filter(Boolean);
   if(currentUser.isPowerUser===true)
    {
     
   const matchedList = selectBoxValues.filter(item =>
     result.enrolled.some(enroll => enroll.id_user === item.value)
   );
       const zip = new JSZip();

       for (const item of matchedList) {
           const blob = await pdf(
               <EnrollPDFMyDocumentBT30
                   enrolledSessionList={filteredList}
                   result={result}
                   currentUser={currentUser}
                   selectBoxValues={[item]}
                   onlineSessions={onlineSessions}
               />
           ).toBlob();

           zip.file(item.label + ".pdf", blob);
       }

       const now = new Date();
       const formattedDate = now.toISOString().split("T")[0];
       const customDate = `${now.getDate().toString().padStart(2, "0")}-${(now.getMonth() + 1)
           .toString()
           .padStart(2, "0")}-${now.getFullYear()}`;

       const content = await zip.generateAsync({ type: "blob" });
       saveAs(content, `${currentUser.username}_${customDate}.zip`);
   setLoading(false);
    }
    else{
   const blob = await pdf(
            <EnrollPDFMyDocumentBT30
              enrolledSessionList={filteredList}
             result={result}
             currentUser={currentUser}
             selectBoxValues={selectBoxValues}
             onlineSessions={onlineSessions}
            />,
          ).toBlob();
          const url = URL.createObjectURL(blob);
          setLoading(false);
          window.open(url, "_blank");
        }
  }
  else{
    const blob = await pdf(
            <EnrollPDFMyDocumentBT30
              enrolledSessionList={[]}
             result={result}
             currentUser={currentUser}
             selectBoxValues={selectBoxValues}
             onlineSessions={[]}
            />,
          ).toBlob();
          const url = URL.createObjectURL(blob);
          setLoading(false);
          window.open(url, "_blank");
  }
    
    };

  const renderChild = () => {
    switch (currentStep) {
      case 1:
        if(currentUser.isPowerUser===false)
        {
          if(currentUser.activeTrainingRequirement==="Continuing Education" || currentUser.activeTrainingRequirement==="" || currentUser.activeTrainingRequirement===null)
          {
          if(currentUser.AHCASEligible===1)
          {
         
           
 return (
          
          <LanguageList
            languages={languages}
            setLanguages={setLanguages}
            selectedLanguage={selectedLanguage}
            setSelectedLanguage={setSelectedLanguage}
            goNext={() => setCurrentStep(2)}
          />
       );
          }
          else{
              setCurrentStep(5);
setErrorMesgaeStep(1);
          }
          }
          else{
             return (
          
          <LanguageList
            languages={languages}
            setLanguages={setLanguages}
            selectedLanguage={selectedLanguage}
            setSelectedLanguage={setSelectedLanguage}
            goNext={() => setCurrentStep(2)}
          />
        );
          }
         
        }
        else{
           return (
          
          <LanguageList
            languages={languages}
            setLanguages={setLanguages}
            selectedLanguage={selectedLanguage}
            setSelectedLanguage={setSelectedLanguage}
            goNext={() => setCurrentStep(2)}
          />
        );
        }
       
      case 2:
        const selectedLangArray = languages.filter(
          (lang) => lang.languagecode === selectedLanguage
        );
        return (
          <LearningPlans
            languages={selectedLangArray}
            validationATV3Loading={validationATV3Loading}
            handleSelectedPlan={handleSelectPlan}
          />
        );
      case 3:
        return (
          <ScheduleList
            selectedLearningPlan={learningPlan}
            isBT30={isBT30}
            isAvailableCountLoading={isAvailableCountLoading}
            groupedSession={filteredSessions}
            groupedSession2={availableCountData}
            cities={cities}
            handleSelectedSessionToParent={handleSelectedSessionToParent}
            onGoToEnrollmentClick={onGoToEnrollmentClick}
            availableSeats={selectedSession.seats}
            conformationText={conformationText}
          />
        );
      case 4:
        return <ReviewConfirmCourses onlineSessions={onlineSessions} />;
      case 5:
        return <CompletedPage goBack={goBack} page={errorMesgaeStep}/>;
      default:
        return null;
    }
  };

  return (
    <div>
      <ContainerCard
        step={currentStep}
        totalSteps={totalStep}
        heading={stepContent[currentStep].heading}
        subheading={stepContent[currentStep].subheading}
        onPrev={handlePrev}
        handleActionChange={handleActionChange}
        isBT30={isBT30}
        isSessionSelected={isSessionSelected}
        isAvailableCountLoading={isAvailableCountLoading}
        isPowerUser={currentUser.isPowerUser}
        availableSeats={selectedSession.seats}
      >
        {loading ? (
          <div className="container p-3 mt-3">
            <div className="row">
              <h6 className="text-center color-grey pt-5">
                <Spinner animation="border" />
              </h6>
            </div>
          </div>
        ) : (
          renderChild()
        )}
      </ContainerCard>

      {currentUser.isPowerUser ? (
        <Modal
          centered
          show={showEnrollModal}
          onHide={() => {
            setShowEnrollModal(false);
            setEnrollBt30Loading(false);
          }}
        >
          <ModalHeader
            style={{
              height: "50px",
              backgroundColor: "#e4e1ef",
              paddingRight: "8px",
            }}
          >
            <div
              style={{
                display: "flex",
                justifyContent: "space-between",
                width: "100%",
                alignItems: "center",
              }}
            >
              <div className="container-heading" style={{ color: "#441968" }}>
                Select group and users for enrollment
              </div>
              <CustomTooltip text="Close" placement="top">
                <button
                  className="btn-close"
                  style={{ color: "black", marginRight: "4px" }}
                  onClick={() => {
                    setShowEnrollModal(false);
                    setLoading(false);
                  }}
                ></button>
              </CustomTooltip>
            </div>
          </ModalHeader>
          <Modal.Body>
            <div className="row">
              <div className="mb-3">
                Select Group{" "}
                <Select
                  ref={enrollSelectBox}
                  options={defaultListGroupOptions}
                  onChange={handleSelectChangeGroup}
                  isLoading={isListBoxLoading}
                  filterOption={filterOptions}
                  value={selectBoxValuesGroup}
                />
              </div>
              <div className="mb-3">
                Select Users{" "}
                <Select
                  ref={enrollSelectBox}
                  options={defaultListOptions}
                  isMulti
                  onChange={setSelectBoxValues}
                  isLoading={isListBoxLoading}
                  filterOption={filterOptions}
                />
              </div>
            </div>
            <div hidden={!loading} className=""></div>
          </Modal.Body>
          <Modal.Footer>
            <div
              style={{
                width: "100%",
                display: "flex",
                justifyContent: "center",
                gap: "14px",
              }}
            >
              <button
                className="secondary_button"
                style={{ width: "120px" }}
                onClick={() => {
                  setShowEnrollModal(false);
                }}
              >
                Close
              </button>
              <button
                style={{ width: "120px" }}
                className={`${
                  !selectBoxValues || selectBoxValues.length === 0
                    ? "button-disabled"
                    : "button"
                }`}
                disabled={
                  loading || !selectBoxValues || selectBoxValues.length === 0
                }
                onClick={() => onModalEnrollClickHandler("BT30 Enroll")}
              >
                <Spinner
                  className="me-1"
                  as="span"
                  animation="border"
                  size="sm"
                  role="status"
                  aria-hidden="true"
                  hidden={!enrollBt30Loading}
                />
                Enroll
              </button>
            </div>
          </Modal.Footer>
        </Modal>
      ) : (
        <Modal
          centered
          show={showEnrollConfirm}
          onHide={() => setShowEnrollConfirm(false)}
        >
          <Modal.Header style={{ borderBottom: "none" }}>
            <span
              style={{
                fontWeight: "bold",
                fontSize: "22px",
                paddingLeft: "4px",
              }}
            >
              Confirm Enrollment
            </span>
            <CustomTooltip text="Close" placement="top">
              <button
                type="button"
                className="btn-close"
                aria-label="Close"
                onClick={() => setShowEnrollConfirm(false)}
              ></button>
            </CustomTooltip>
          </Modal.Header>

          <Modal.Body
            style={{
              borderTop: "none",
              borderBottom: "none",
              paddingTop: "0px",
            }}
          >
            <div className="row" style={{ paddingLeft: "8px" }}>
              <div className="mb-3" style={{ whiteSpace: "pre-line" }}>
                {conformationText}
              </div>
            </div>
            <div hidden={!loading}></div>
          </Modal.Body>
          <Modal.Footer
            className="d-flex justify-content-center gap-2"
            style={{ borderTop: "none" }}
          >
            <button
              className="btn btn-secondary"
              style={{
                backgroundColor: "white",
                color: "#007fa3",
                border: "1px solid #007fa3",
                width: "120px",
              }}
              onClick={() => {
                setShowEnrollConfirm(false);
              }}
            >
              Close
            </button>
            <button
              className="btn secondary"
              style={{
                width: "120px",
              }}
              disabled={loading}
              onClick={() => {
                onConfirmEnrollClick();
              }}
            >
              <Spinner
                className="me-1"
                as="span"
                animation="border"
                size="sm"
                role="status"
                aria-hidden="true"
                hidden={!enrollBt30Loading}
              />
              Confirm
            </button>
          </Modal.Footer>
        </Modal>
      )}

      <ConfirmationScreen
        isOpen={showViewDashboardPopup}
        onClose={() => {
          setShowViewDashboardPopup(false);
          setLoading(false);
          setEnrollBt30Loading(false);
        }}
      >
        <div className="bt30-enrolled-table">
          <div className="bt30-enrolled-table__content">
            <div className="bt30-enrolled-table__message">
              <div className="bt30-enrolled-table__icon">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="80"
                  height="80"
                  viewBox="0 0 64 64"
                  fill="none"
                >
                  <circle cx="32" cy="32" r="32" fill="#0DB421" />
                  <path
                    d="M18 33L28 43L46 25"
                    stroke="white"
                    strokeWidth="4"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  />
                </svg>
              </div>

              

                {currentUser.isPowerUser ? (
              <div className="confirmation-title">
                Below are the details of your enrollment.
              </div>
            ) : (
              <>
               {result?.enrolled?.length > 0 && (
                <div className="bt30-enrolled-table__title success">
                  {currentUser.isPowerUser ? "": currentUser.username+","} You have successfully enrolled into {result?.enrolled?.length}{" "}
                  In-person {result?.enrolled?.length >1?"classes":"class"} and {onlineSessions?.length} online courses.
                </div>
              )}

              {result?.existing_enrollments?.length > 0 && (
                <div className="bt30-enrolled-table__title error">
                  {currentUser.isPowerUser ? "": currentUser.username+","}  You are already enrolled in the following classes.
                </div>
              )}
              </>
            )}

            </div>

            <div className="bt30-enrolled-table__actions">
              {currentUser.isPowerUser ?( <button
                className="button"
                onClick={() =>
                    (selectBoxValuesGroup?.label ?? "").toLowerCase().includes("employer".toLowerCase())?
 (
  window.top.location.href =
                            process.env.REACT_APP_EMPLOYERS_HOME_PAGE_URL)
                    :
(window.top.location.href =
                            process.env.REACT_APP_MRC_HOME_PAGE_URL)
                }
              >
                              {
                                  (selectBoxValuesGroup?.label ?? "").toLowerCase().includes("employer".toLowerCase()) ? "Employer Home Page" : "MRC Home Page"
                              }
              </button>):( <button
                className="button"
                onClick={() =>
                  (window.top.location.href =
                    learningPlan.dashboardUrl)
                }
              >
                Enroll in Electives
              </button>)}
{
            result?.enrolled?.length>0 && <button className="button" onClick={() => handlePrintData(enrolledSessionList,result,currentUser,onlineSessions)}>Print</button>
          }
            </div>
 
            <div className="bt30-enrolled-data">
              <div
                className="bt30-enrolled-table__section"
                style={{ border: "none" }}
              >
                <div
                  className="bt30-enrolled-table__section-title"
                  style={{
                    borderBottom: "2px solid #f3f3f4",
                    padding: "8px 0px 8px 0px",
                  }}
                >
                  In-Person
                </div>
                {enrolledSessionList?.length > 0 ? (
                  enrolledSessionList.map((group, index) => (
                    <div key={index} className="bt30-enrolled-table__group">
                      {group["1"].map((entry, subIndex) => (
                        <div
                          key={subIndex}
                          className="bt30-enrolled-table__row"
                          style={{ paddingBottom: "8px" }}
                        >
                          <div className="">
                            <div className="bt30-enrolled-table__date-location">
                              <div className="bt30-enrolled-table__date">
                                {group["0"]}
                              </div>
                            </div>
                            <div className="bt30-enrolled-table__date-time">
                              <div className="bt30-enrolled-table__time">
                                {entry.startTime} - {entry.endTime}
                              </div>
                            </div>
                          </div>

                          <div
                            className="bt30-enrolled-table__location"
                            style={{ paddingLeft: "8px" }}
                          >
                            <div className="bt30-enrolled-table__city">
                              {entry.city}
                            </div>
                            <div
                              className="bt30-enrolled-table__location-link"
                              onClick={() => {
                                setSelectedLocation(entry.cityLink);
                                setShowLocationModal(true);
                              }}
                            >
                              {entry.cityLink?.name}
                            </div>
                          </div>

                          <div className="bt30-enrolled-table__module">
                            {entry.module}
                          </div>

                          {/* <div
                            className="bt30-enrolled-table__status"
                            style={{
                              textAlign: "center",
                              display: "flex",
                              justifyContent: "center",
                              minWidth: "150px",
                              whiteSpace: "nowrap",
                              color:
                                entry.enrolledStatus === "Enrolled"
                                  ? "green"
                                  : entry.enrolledStatus === "Already Enrolled"
                                    ? "#d32f2f"
                                    : "orange",
                            }}
                          >
                            {entry.enrolledStatus || "-"}
                          </div> */}

                          {currentUser.isPowerUser ? (
                          <div>
                            {result?.enrolled?.filter(
                              (e) => e.id_course === Number(entry.courseId),
                            ).length > 0 && (
                              <p style={{ color: "green" }}>
                               
                                Enrolled: {" "}
                                {result.enrolled
                                  .filter(
                                    (e) =>
                                      e.id_course === Number(entry.courseId),
                                  )                                
                                  .map((e) => {
                                          const user = selectBoxValues.find(
                                            (u) => u.value === e.id_user
                                          );
                                          return user?.label;
                                        })
                                        .filter(Boolean)
                                  .join(", ")}
                              </p>
                            )}

                            {
                            result?.extsingEnroll_Data?.filter(
                              (e) => e.id_course === Number(entry.courseId),
                            ).length > 0 && (
                              <p style={{ color: "red" }}>
                                Already Enrolled: {" "}
                                {result.extsingEnroll_Data
                                  .filter(
                                    (e) =>
                                      e.id_course === Number(entry.courseId),
                                  )
                                  .map((e) => {
                                          const user = selectBoxValues.find(
                                            (u) => u.value === e.id_user
                                          );
                                          return user?.label;
                                        })
                                        .filter(Boolean)
                                  .join(", ")}
                              </p>
                            )}

                            {result?.penddingsessions?.filter(
                              (e) =>
                                Number(e.id_course) === Number(entry.courseId),
                            ).length > 0 && (
                              <p style={{ color: "blue" }}>
                                Not Enrolled: {" "}
                                {
                                result.penddingsessions
                                  .filter(
                                    (e) =>
                                      Number(e.id_course) ===
                                      Number(entry.courseId),
                                  )
                                  .map((e) => {
                                          const user = selectBoxValues.find(
                                            (u) => u.value === e.id_user
                                          );
                                          return user?.label;
                                        })
                                        .filter(Boolean)
                                  .join(", ")}
                              </p>
                            )}
                          </div>
                        ) : (
                          <div
                            className="bt30-enrolled-table__status"
                            style={{
                              textAlign: "center",
                              display: "flex",
                              justifyContent: "center",
                              minWidth: "150px",
                              whiteSpace: "nowrap",
                              color:
                                entry.enrolledStatus === "Enrolled"
                                  ? "green"
                                  : entry.enrolledStatus === "Already Enrolled"
                                    ? "#d32f2f"
                                    : "orange",
                            }}
                          >
                            {entry.enrolledStatus || "-"}
                          </div> 
                        )}
                        </div>
                      ))}
                    </div>
                  ))
                ) : (
                  <div className="bt30-enrolled-table__empty">
                    No record(s) found.
                  </div>
                )}
              </div>

              <div className="bt30-enrolled-table__section">
                <div className="bt30-enrolled-table__section-title">Online</div>
                <div className="bt30-enrolled-table__description">
                  Online classes are available to start at any time, and
                  recommended to start as soon as possible in order to meet your
                  training deadline.
                </div>
              </div>

              <div
                className={`bt30-enrolled-table__online ${onlineSessions?.length > 0 ? "has-data" : ""}`}
              >
                {onlineSessions?.length > 0 ? (
                  onlineSessions
                    .sort((a, b) => a.SequenceOrder - b.SequenceOrder)
                    .map((session) => (
                      <div
                        key={session.CourseId}
                        className="bt30-enrolled-enrolled_table_enrolled_row"
                      >
                        <div className="bt30-enrolled-table__hours">
                          {session.Credits}{" "}
                          {session.Credits > 1 ? "hours" : "hour"}
                        </div>
                        <div className="bt30-enrolled-mode">Online</div>
                        <div className="bt30-enrolled-table__course-name">
                          {session.CourseName}
                        </div>
                      </div>
                    ))
                ) : (
                  <div className="bt30-enrolled-table__empty">
                    No record(s) found.
                  </div>
                )}
              </div>
            </div>
          </div>
        </div>
      </ConfirmationScreen>
      <LocationModal
        isOpen={showLocationModal}
        onClose={() => setShowLocationModal(false)}
        location={selectedLocation}
      />
      <InpersonClassSelectionModal
        isOpen={showInpersonSelectionModal}
        onClose={() => setShowInpersonSelectionModal(false)}
        continueEnrollingBt30={continueEnrollingBt30}
        selectedSession={selectedSession}
      />
    </div>
  );
};

export default LandingPage;
